import cloneDeep from 'lodash/cloneDeep';

import type { MailParams } from '@webapp/account/src/resources/mailing';
import type { GlobalFilter } from '@webapp/account/src/resources/reports/global-filters';
import { initialGlobalFilter } from '@webapp/account/src/resources/reports/global-filters';

import type { SurveyAddonAlert } from '@webapp/common/resources/entities/survey-addons/alert';
import { initialSurveyAddonAlert } from '@webapp/common/resources/entities/survey-addons/alert';
import type { SurveyAddonBrand } from '@webapp/common/resources/entities/survey-addons/brand';
import { initialSurveyAddonBrand } from '@webapp/common/resources/entities/survey-addons/brand';
import type { SurveyAddonButtons } from '@webapp/common/resources/entities/survey-addons/buttons';
import { initialSurveyAddonButtons } from '@webapp/common/resources/entities/survey-addons/buttons';
import type { SurveyAddonFonts } from '@webapp/common/resources/entities/survey-addons/fonts';
import { initialSurveyAddonFonts } from '@webapp/common/resources/entities/survey-addons/fonts';
import type { SurveyAddonMain } from '@webapp/common/resources/entities/survey-addons/main';
import { initialSurveyAddonMain } from '@webapp/common/resources/entities/survey-addons/main';
import type { SurveyAddonParams } from '@webapp/common/resources/entities/survey-addons/params';
import { initialSurveyAddonParams } from '@webapp/common/resources/entities/survey-addons/params';
import type { SurveyAddonShare } from '@webapp/common/resources/entities/survey-addons/share';
import { initialSurveyAddonShare } from '@webapp/common/resources/entities/survey-addons/share';
import type { SurveyAddonTests } from '@webapp/common/resources/entities/survey-addons/tests';
import { initialSurveyAddonTests } from '@webapp/common/resources/entities/survey-addons/tests';
import type { SurveyAddonView } from '@webapp/common/resources/entities/survey-addons/view';
import { initialSurveyAddonView } from '@webapp/common/resources/entities/survey-addons/view';

import type { Css } from './css';
import { initialCss } from './css';
import type { Embed } from './embed';
import { initialEmbed } from './embed';
import type { Notify } from './notify';
import { initialNotify } from './notify';
import type { Popup } from './popup';
import { initialPopup } from './popup';
import type { Widget } from './widget';
import { initialWidget } from './widget';

export interface Addons {
    [key: string]: any;

    main: SurveyAddonMain;
    params: SurveyAddonParams;
    buttons: SurveyAddonButtons;
    alert: SurveyAddonAlert;
    tests: SurveyAddonTests;

    fonts: SurveyAddonFonts;
    view: SurveyAddonView;
    brand: SurveyAddonBrand;
    css: Css;

    widget: Widget;
    popup: Popup;
    embed: Embed;

    filters: GlobalFilter;
    notify: Notify;
    share: SurveyAddonShare;
    mailing: MailParams;
}

export enum AddonList {
    MAIN = 'main',
    PARAMS = 'params',
    BUTTONS = 'buttons',
    ALERT = 'alert',
    TESTS = 'tests',

    FONTS = 'fonts',
    VIEW = 'view',
    BRAND = 'brand',
    CSS = 'css',

    WIDGET = 'widget',
    POPUP = 'popup',

    EMBED = 'embed',

    SHARE = 'share',

    FILTERS = 'filters',
    NOTIFY = 'notify',
}

export enum AddonListMain {
    COMPLETE_PAGE = 'completePage',
    SHOW_TEST_RESULT = 'showResultTest',
    SHOW_DONE_TEST = 'showDoneTest',
    TIMER = 'timer',
    TIMER_ON = 'timerOn',
    TIMER_HOURS = 'timerHours',
    TIMER_MINUTES = 'timerMinutes',
    TIMER_SECONDS = 'timerSeconds',
}

export const initialAddons: Readonly<Addons> = {
    widget: cloneDeep(initialWidget),
    popup: cloneDeep(initialPopup),
    alert: cloneDeep(initialSurveyAddonAlert),
    brand: cloneDeep(initialSurveyAddonBrand),
    buttons: cloneDeep(initialSurveyAddonButtons),
    embed: cloneDeep(initialEmbed),
    fonts: cloneDeep(initialSurveyAddonFonts),
    main: cloneDeep(initialSurveyAddonMain),
    params: cloneDeep(initialSurveyAddonParams),
    tests: cloneDeep(initialSurveyAddonTests),
    view: cloneDeep(initialSurveyAddonView),
    css: cloneDeep(initialCss),
    filters: cloneDeep(initialGlobalFilter),
    notify: cloneDeep(initialNotify),
    share: cloneDeep(initialSurveyAddonShare),
    mailing: null,
};
